

export class VehicleTypeAlertGroupInput implements IVehicleTypeAlertGroupInput {
    /** The auto-generated id of the vehicle type group master */
    vehicleTypeId!: number;

    constructor(data?: IVehicleTypeAlertGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleTypeId = _data["vehicleTypeId"];
        }
    }

    static fromJS(data: any): VehicleTypeAlertGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypeAlertGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleTypeId"] = this.vehicleTypeId;
        return data; 
    }
}

export interface IVehicleTypeAlertGroupInput {
    /** The auto-generated id of the vehicle type group master */
    vehicleTypeId: number;
}

